import { makeAutoObservable } from 'mobx'

/**
 * Tracks imperative requests to hide the HubSpot chat widget from surfaces that
 * can't be distinguished by route alone — e.g. the pre-session quiz, which is a
 * full-screen dialog rendered on top of the current route (the URL does not
 * change). Reference-counted so overlapping suppressors behave correctly.
 */
class HubSpotChatStore {
  private suppressorCount = 0

  constructor() {
    makeAutoObservable(this)
  }

  get isSuppressed() {
    return this.suppressorCount > 0
  }

  addSuppressor() {
    this.suppressorCount += 1
  }

  removeSuppressor() {
    this.suppressorCount = Math.max(0, this.suppressorCount - 1)
  }
}

export const hubspotChatStore = new HubSpotChatStore()
